import { FieldType } from '@wix/wix-data-schema-types'
import {
  string,
  optional,
  boolean,
  objectProperties,
  list,
} from './utils/validate'

const genericFieldTypeConfigSchema = {
  type: optional(string),
  displayName: optional(string),
  pluginId: optional(string),
  plugin: optional(string),
  queryOperators: optional(list(string)),
  systemField: optional(boolean),
  sortable: optional(boolean),
  isDeleted: optional(boolean),
  pii: optional(boolean),
  readOnly: optional(boolean),
  description: optional(string),
}

const pagelinkSchema = {
  linkedRouterPage: string,
  calculator: objectProperties({
    id: string,
    config: objectProperties({
      pattern: string,
      lowercase: optional(boolean),
    }),
  }),
  ...genericFieldTypeConfigSchema,
}

const referenceTypeConfigSchema = {
  referencedCollection: string,
  ...genericFieldTypeConfigSchema,
}

const multiReferenceTypeConfigSchema = {
  referencingFieldKey: string,
  referencingDisplayName: string,
  ...referenceTypeConfigSchema,
}

export {
  genericFieldTypeConfigSchema,
  pagelinkSchema,
  referenceTypeConfigSchema,
  multiReferenceTypeConfigSchema,
}

export default {
  default: genericFieldTypeConfigSchema,
  [FieldType.pageLink]: pagelinkSchema,
  [FieldType.reference]: referenceTypeConfigSchema,
  [FieldType.multiReference]: multiReferenceTypeConfigSchema,
}
